import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'banner', 'trigger' ]

  connect() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.bannerTarget.classList.add('is-active')
          this.observer.unobserve(this.triggerTarget)
        }
      })
    })
    this.observer.observe(this.triggerTarget)
  }

  disconnect() {
    this.observer.disconnect()
    this.observer = null
  }

  close() {
    this.bannerTarget.classList.remove('is-active')
  }
}
